// extracted by mini-css-extract-plugin
export default {"list":"OrdersCustomer_list__WAUEP"};